/* node_modules\@storybook\svelte\templates\PreviewRender.svelte generated by Svelte v3.49.0 */
import {
	SvelteComponent,
	create_component,
	destroy_component,
	init,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import SlotDecorator from './SlotDecorator.svelte';
import dedent from 'ts-dedent';

function create_fragment(ctx) {
	let slotdecorator;
	let current;

	slotdecorator = new SlotDecorator({
			props: {
				decorator: /*Wrapper*/ ctx[3],
				decoratorProps: /*WrapperData*/ ctx[4],
				component: /*Component*/ ctx[0],
				props: /*props*/ ctx[1],
				on: /*on*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(slotdecorator.$$.fragment);
		},
		m(target, anchor) {
			mount_component(slotdecorator, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(slotdecorator.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(slotdecorator.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(slotdecorator, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { name } = $$props;
	let { kind } = $$props;
	let { storyFn } = $$props;
	let { showError } = $$props;

	const { /** @type {SvelteComponent} */
	Component, /** @type {any} */
	props = {}, /** @type {{[string]: () => {}}} Attach svelte event handlers */
	on, Wrapper, WrapperData = {} } = storyFn();

	if (!Component) {
		showError({
			title: `Expecting a Svelte component from the story: "${name}" of "${kind}".`,
			description: dedent`
        Did you forget to return the Svelte component configuration from the story?
        Use "() => ({ Component: YourComponent, data: {} })"
        when defining the story.
      `
		});
	}

	$$self.$$set = $$props => {
		if ('name' in $$props) $$invalidate(5, name = $$props.name);
		if ('kind' in $$props) $$invalidate(6, kind = $$props.kind);
		if ('storyFn' in $$props) $$invalidate(7, storyFn = $$props.storyFn);
		if ('showError' in $$props) $$invalidate(8, showError = $$props.showError);
	};

	return [Component, props, on, Wrapper, WrapperData, name, kind, storyFn, showError];
}

class PreviewRender extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			name: 5,
			kind: 6,
			storyFn: 7,
			showError: 8
		});
	}
}

export default PreviewRender;
PreviewRender.__docgen = {"version":3,"name":"PreviewRender.svelte","data":[{"visibility":"public","description":null,"keywords":[],"name":"name","kind":"let","static":false,"readonly":false,"type":{"kind":"type","text":"any","type":"any"}},{"visibility":"public","description":null,"keywords":[],"name":"kind","kind":"let","static":false,"readonly":false,"type":{"kind":"type","text":"any","type":"any"}},{"visibility":"public","description":null,"keywords":[],"name":"storyFn","kind":"let","static":false,"readonly":false,"type":{"kind":"type","text":"any","type":"any"}},{"visibility":"public","description":null,"keywords":[],"name":"showError","kind":"let","static":false,"readonly":false,"type":{"kind":"type","text":"any","type":"any"}}],"computed":[],"methods":[],"components":[],"description":null,"keywords":[],"events":[],"slots":[],"refs":[]};